export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  tokenKey: 'fd-tokens',
  profileKey: 'user',
  layoutSettingsKey: 'fd-layout',
  languageCookieKey: 'lang',
  permissionKey: 'permissionKey',
  userPermissionsKey: 'userPermissionsKey',
  cookieExpireTime: 30 * 24 * 60 * 60,
  apiUrl: 'https://app-api.nirlat.com/api',
  imageUrl: 'https://nirlat-assets.s3.il-central-1.amazonaws.com/',
  publicUrl: 'https://app-api.nirlat.com/',
  awsenv: 'stage',
};
